<template>
  <div class="hello">
    <nav class="navbar navbar-inverse site-navbar">
      <div class="yem-top">
        <div class="container"></div>
      </div>
      <div class="top-logo">
        <div class="container">
          <div class="row">
            <div class="pull-left">
              <a href="index.html">
                <img src="../../assets/images/logo.png" class="logo-index" />
              </a>
            </div>
            <div class="pull-right">
              <p><i class="glyphicon glyphicon-earphone"></i>0411-82817405</p>
            </div>
          </div>
        </div>
      </div>
      <div class="about-nav-py">
        <div class="container">
          <div class="navbar-header">
            <img src="../../assets/images/logo.png" class="meblie-logo" />
            <button
              type="button"
              class="navbar-toggle collapsed jicheng"
              data-toggle="collapse"
              data-target="#navbar"
              aria-expanded="false"
              aria-controls="navbar"
            >
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
          </div>
          <div id="navbar" class="collapse navbar-collapse">
            <ul class="nav navbar-nav nav-top-quanju">
              <li>
                <router-link to="/">首页</router-link>
              </li>
              <li>
                <router-link to="/aboutPage">企业介绍</router-link>
              </li>
              <li>
                <router-link to="/contactPage"  class="active-daohang">联系我们</router-link>
              </li>
              <li>
                <a href="javascript:void(null);" @click="openRegisteredDialog">注册</a>
              </li>
              <li>
                <a href="javascript:void(null);"  @click="openLoginDialog">登录</a>
              </li>
            </ul>
          </div>
          <!--/.nav-collapse -->
        </div>
      </div>
    </nav>
    <div id="wrapper">
      <div class="fullwidthbanner-container">
        <div class="fullwidthbanner">
          <ul>
            <li
              data-transition="papercut"
              data-slotamount="15"
              data-masterspeed="300"
              data-link="#"
            >
              <img src="../../assets/images/slide1.jpg" alt="" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="s_ctn clearfix">
        <div class="ct clearfix">
          <div class="ct_l">
            <h1>中国国际海运网-WIFFA云单系统</h1>
            <p>地址：辽宁省大连市中山区人民路50号时代广场B座1601</p>
            <p>TEL：0411-82817405</p>
            <p>Service TEL：86-411-82817405</p>
            <p>E-mail：tousu-7700@qq.com</p>
            <p>Site：http：//www.shippingchina.com</p>
          </div>
          <div class="ct_r">
              <img src="../../assets/images/location.png" width="700" height="360" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <div class="row">
          <div class="col-md-3">版权所有：国际海运网</div>
          <div class="col-md-3">联系电话：0411-82817405</div>
          <div class="col-md-3">联系人：刘先生</div>
          <div class="col-md-3">
            联系地址：辽宁省大连市中山区人民路50号时代广场B座1601
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 footer-bottom">Copyright © 2020-2025</div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogRegisteredVisible" width="500px" :close-on-click-modal="false">
      <Register :isShow="dialogRegisteredVisible"></Register>
    </el-dialog>

    <el-dialog class="no-bg" :visible.sync="dialogLoginVisible" width="500px" :close-on-click-modal="false">
      <Login></Login>
    </el-dialog>
  </div>
</template>

<script>
  import Login from '@/views/home/login/Login.vue'
  import Register from '@/views/home/register/Register.vue'
export default {
  name: 'contactPage',
  components: {Login, Register},
  data () {
    return {
      dialogRegisteredVisible: false,
      dialogLoginVisible: false,
      form: {
        name: '',
        region: ''
      },
      formLabelWidth: '120px'
    }
  },
  methods: {
    openRegisteredDialog: function () {
      this.dialogRegisteredVisible = true
    },
    openLoginDialog: function () {
      this.dialogLoginVisible = true
    }
  }
}
</script>
<style src="../../assets/css/bootstrap.min.css" scoped></style>
<style src="../../assets/css/tf.css" scoped></style>
<style src="../../assets/css/style1.css" scoped></style>
<style scoped>
/*@import "../../assets/css/bootstrap.min.css";
@import "../../assets/css/tf.css";
@import "../../assets/css/style.css";*/
.s_ctn {
  padding: 30px 0;
  text-align: left;
  font-size: 13px;
  color: #555;
  line-height: 205%;
}
.ct {
  width: 100%;
}
.ct_l {
  width: 540px;
  float: left;
}
.ct_l h1 {
  padding: 15px 0;
  font-weight: normal;
  font-size: 20px;
  color: #005798;
}
.ct_l p {
  width: 100%;
  font-size: 14px;
  color: #555555;
  margin-bottom: 10px;
  line-height: 200%;
  font-style: normal;
  font-weight: normal;
}
ol,
ul {
  list-style: none;
}
.ct_r {
  width: 470px;
  float: right;
  margin-right: 15px;
}
.ct_r input {
  width: 390px;
  height: 35px;
  border: 1px solid #ddd;
  line-height: 35px;
  padding: 0 5px;
  float: left;
  font-size: 13px;
}
.ct_r .tit {
  display: block;
  width: 60px;
  height: 35px;
  line-height: 35px;
  text-align: right;
  font-size: 13px;
  float: left;
  color: #333333;
}
.clearfix {
  display: block;
}
/* /deep/ .no-bg .el-dialog, .el-pager li {
  box-shadow: 0 1px 3px rgba(0,0,0,0);
  background: #FFFFFF00;
} */
</style>
